import { createIcon } from '@chakra-ui/react';

export const LockIcon = createIcon({
  displayName: 'LockIcon',
  viewBox: '0 0 17 20',
  path: [
    <path
      key="1"
      opacity="1"
      d="M7.97742 0.00834216C11.8255 -0.179371 14.9228 2.82404 14.9228 6.67217C14.9228 6.95374 14.7351 7.04759 14.5474 7.04759H12.858C12.5764 7.04759 12.4825 6.95374 12.4825 6.67217V6.76602C12.4825 4.51346 10.7931 2.63633 8.63441 2.44862C6.19414 2.2609 4.22315 4.23189 4.22315 6.57831C4.22315 6.85988 4.03544 6.95374 3.84772 6.95374H2.1583C1.97059 6.95374 1.78288 6.76602 1.78288 6.57831C1.78288 3.19947 4.50472 0.196056 7.97742 0.00834216Z"
      fill="#AAAAAA"
    />,
    <path
      key="2"
      opacity="1"
      d="M10.2302 16.9027C10.3241 17.1843 10.1364 17.4658 9.85478 17.4658H6.75751C6.47594 17.4658 6.28823 17.1843 6.38209 16.9027L7.13294 14.4624C6.47594 14.087 6.10052 13.3362 6.28823 12.4914C6.47594 11.7406 7.03908 11.0836 7.88379 10.8959C9.19779 10.6143 10.3241 11.5529 10.3241 12.8669C10.3241 13.5239 9.94864 14.1809 9.47936 14.4624L10.2302 16.9027ZM14.9232 8.73712H1.68942C0.750853 8.73712 0 9.48798 0 10.4265V18.3105C0 19.2491 0.750853 19.9999 1.68942 19.9999H14.9232C15.8618 19.9999 16.6126 19.2491 16.6126 18.3105V10.4265C16.6126 9.48798 15.8618 8.73712 14.9232 8.73712Z"
      fill="#AAAAAA"
    />
  ]
});
